import { useEffect, useState } from "react";
import moment from "moment";
import { StockData } from "../ui/top-stocks-section/TopAnalystConsensusStocks";
import { IStocksDto, IAnalystTrendsDto, IAnalyst, IAnalystsConsensus } from "../../../../../../services/tipRanks/types";
import { analystForecastsApi } from "../api/analystForecastApi";

const getMonthForecastData = (analystsConsensus: any, consensusOverTime: any) => {
    if (!analystsConsensus) return null;

    // const historyMonthForecast = [
    //     {
    //         date: "2024-04-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 57,
    //         hold: 36,
    //         sell: 9,
    //         // strongSell: 0,
    //         price: 70,
    //     },
    //     {
    //         date: "2024-05-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 76,
    //         hold: 46,
    //         sell: 19,
    //         //strongSell: 0,
    //         price: 135,
    //     },
    //     {
    //         date: "2024-06-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 93,
    //         hold: 56,
    //         sell: 29,
    //         // strongSell: 0,
    //         price: 140,
    //     },
    //     {
    //         date: "2024-07-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 100,
    //         hold: 66,
    //         sell: 39,
    //         // strongSell: 0,
    //         price: 149,
    //     },
    //     {
    //         date: "2024-08-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 96,
    //         hold: 76,
    //         sell: 49,
    //         // strongSell: 0,
    //         price: 200,
    //     },
    //     {
    //         date: "2024-09-01T00:00:00Z",
    //         //strongBuy: 0,
    //         buy: 100,
    //         hold: 86,
    //         sell: 59,
    //         // strongSell: 0,
    //         price: 190,
    //     },
    //     {
    //         date: "2024-10-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 101,
    //         hold: 96,
    //         sell: 69,
    //         //strongSell: 0,
    //         price: 220,
    //     },
    //     {
    //         date: "2024-11-01T00:00:00Z",
    //         //strongBuy: 0,
    //         buy: 88,
    //         hold: 106,
    //         sell: 79,
    //         // strongSell: 0,
    //         price: 250,
    //     },
    //     {
    //         date: "2024-12-01T00:00:00Z",
    //         // strongBuy: 0,
    //         buy: 156,
    //         hold: 116,
    //         sell: 89,
    //         // strongSell: 0,
    //         price: 270,
    //     },
    //     {
    //         date: "2025-01-01T00:00:00Z",
    //         //strongBuy: 0,
    //         buy: 166,
    //         hold: 126,
    //         sell: 99,
    //         // strongSell: 0,
    //         price: 300,
    //     },
    //     {
    //         date: "2025-02-01T00:00:00Z",
    //         //strongBuy: 0,
    //         buy: 176,
    //         hold: 136,
    //         sell: 109,
    //         // strongSell: 0,
    //         price: 295,
    //     },
    //     {
    //         date: "2025-03-01T00:00:00Z",
    //         //strongBuy: 1,
    //         buy: 186,
    //         hold: 146,
    //         sell: 119,
    //         // strongSell: 0,
    //         price: 290,
    //     },
    //     {
    //         date: "2025-04-01T00:00:00Z",
    //         // strongBuy: 1,
    //         buy: 186,
    //         hold: 146,
    //         sell: 119,
    //         // strongSell: 0,
    //         price: 287,
    //     },
    // ];

    return {
        data: consensusOverTime,
        priceTargetUpside: analystsConsensus.priceTargetUpside,
        highEstimate: analystsConsensus.highPriceTarget,
        averageTarget: analystsConsensus.priceTarget,
        lowEstimate: analystsConsensus.lowPriceTarget,
        totalAnalysts: analystsConsensus?.totalAnalysts | 0,
        companyName: analystsConsensus.companyName,
    };
};

const getAnalystForecastsData = (analysts: IAnalyst[], consensus: IAnalystsConsensus) => {
    if (!analysts?.length) return null;

    return {
        data: analysts.map(analyst => ({
            analystInfo: {
                name: analyst.analystName,
                rating: analyst.numOfStars || 0,
                company: analyst.firmName,
                stockAvgReturn: analyst.stockAvgReturn,
                avatar: analyst.expertPictureURL,
            },
            position: analyst.recommendation,
            priceTarget: analyst.priceTarget,
            action: analyst.analystAction,
            date: moment(analyst.recommendationDate, "MM/DD/YYYY").format("DD.MM.YYYY"),
            stockTotalRecommendations: analyst.stockTotalRecommendations,
            stockGoodRecommendations: analyst.stockGoodRecommendations,
        })),
        companyName: consensus.companyName,
    };
};

const getBestAnalystsAndTrends = (consensus: IAnalystsConsensus, trends: IAnalystTrendsDto[]) => {
    // const sortedAnalysts = []
    const averageTarget = consensus?.priceTarget || 0;
    return {
        analysts: [],
        trends: trends,
        averageTarget,
    };
};

const getStocks = (stocks: IStocksDto[]): StockData[] => {
    if (!stocks) return [];
    //@ts-ignore
    return stocks.map(stock => {
        const {
            priceTarget,
            priceTargetUpside,
            percentChange,
        } = stock;

        return {

            symbol: stock?.ticker,
            price: stock.priceTarget || 0, // Default to 0 if no price target available
            change: priceTargetUpside,
            priceTarget: priceTarget,
            changePercent: percentChange.toFixed(2),
            companyName: stock.companyName,
        };

    });
};

const getFinancialForecastData = () => {
    return {
        earningsForecast: [
            { quarter: "Q2 2024", price: 1.5, consensus: 1.4, low: 1.2, high: 1.8 },
            { quarter: "Q3 2024", price: 1.8, consensus: 1.7, low: 1.6, high: 2.0 },
            { quarter: "Q4 2024", price: 1.6, consensus: 1.6, low: 1.5, high: 1.9 },
            { quarter: "Q1 2025", price: 1.9, consensus: 1.8, low: 1.7, high: 2.1 },
            { quarter: "Q2 2025", price: 1.7, consensus: 1.7, low: 1.6, high: 1.9 },
        ],
        salesForecast: [
            { quarter: "Q2 2024", price: 92.4, consensus: 92, low: 91.0, high: 94.0 },
            { quarter: "Q3 2024", price: 85.8, consensus: 86, low: 84.5, high: 88.0 },
            { quarter: "Q4 2024", price: 95.4, consensus: 95, low: 94.0, high: 96.5 },
            { quarter: "Q1 2025", price: 111.3, consensus: 111, low: 110.0, high: 113.0 },
            { quarter: "Q2 2025", price: 87, consensus: 87, low: 86.0, high: 88.5 },
        ],
    };
};

interface IAnalystForecastsData {
    analystRatingsData: IAnalystsConsensus;
    monthForecastData: ReturnType<typeof getMonthForecastData>;
    analystForecastsData: ReturnType<typeof getAnalystForecastsData>;
    bestAnalystsAndTrendsData: ReturnType<typeof getBestAnalystsAndTrends>;
    stocksData: ReturnType<typeof getStocks>;
    financialForecastData: ReturnType<typeof getFinancialForecastData>;
}

export const useSymbolAnalystForecasts = ({
    ticker,
}: {
    ticker: string;
}) => {
    const [data, setData] = useState<Record<string, IAnalystForecastsData> | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!ticker) return;

        if (data?.[ticker] !== undefined) return;

        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = (await Promise.all([
                    analystForecastsApi.getAnalysts(ticker),
                    analystForecastsApi.getIAnalystsConsensus(ticker),
                    analystForecastsApi.getConsensusOverTime(ticker),
                    analystForecastsApi.getTechnologyTopStocks(),
                ])) as [IAnalyst[], IAnalystsConsensus, any[], IStocksDto[]];

                if (!response) return;

                const [analysts, analystsConsensus, consensusOverTime, stocks] = response;

                const processedData = {
                    analystRatingsData: analystsConsensus,
                    monthForecastData: getMonthForecastData(analystsConsensus, consensusOverTime),
                    analystForecastsData: getAnalystForecastsData(analysts, analystsConsensus),
                    bestAnalystsAndTrendsData: getBestAnalystsAndTrends(analystsConsensus, consensusOverTime), // TODO: mock data
                    stocksData: getStocks(stocks),
                    financialForecastData: getFinancialForecastData(), // TODO: mock data
                };

                setData(prev => ({
                    ...(prev || {}),
                    [ticker]: processedData,
                }));
            } catch (error) {
                console.error("Failed to load analyst forecast and consunsus data: ", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [ticker]);

    return {
        ticker,
        isLoading,
        data: data?.[ticker] || null,
    };
};
